// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "stepTitle__icon-2l2iV";
var _4 = "mobileStep__header-1HFoO";
var _5 = "price__total-1j6RC";
var _6 = "price__row-1GcZq";
export { _1 as "__esModule", _2 as "mobile", _3 as "stepTitle__icon", _4 as "mobileStep__header", _5 as "price__total", _6 as "price__row" }
export default { "__esModule": _1, "mobile": _2, "stepTitle__icon": _3, "mobileStep__header": _4, "price__total": _5, "price__row": _6 }
